import React from "react";
import { Route } from "react-router-dom";
import { ConnectedSwitch } from "reactRouterConnected";
import Loadable from "react-loadable";
import Page from "components/LayoutComponents/Page";
import NotFoundPage from "pages/NotFoundPage";
import Dashboard from "pages/Dashboard";

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => null
  });

const loadableRoutes = {
  // Default Pages
  "/login": {
    component: loadable(() => import("pages/LoginPage"))
  },
  "/support": {
    component: loadable(() => import("pages/Support"))
  },
  "/terms": {
    component: loadable(() => import("pages/Terms"))
  },
  "/confirm": {
    component: loadable(() => import("pages/ResetPassword"))
  },
  "/reset/:reset_password_token": {
    component: loadable(() => import("pages/ResetPassword"))
  },
  "/library": {
    component: loadable(() => import("pages/Library"))
  },
  "/patients": {
    component: loadable(() => import("pages/Patients"))
  },
  "/conditions": {
    component: loadable(() => import("pages/Conditions"))
  },
  "/patients/:id": {
    component: loadable(() => import("pages/Patient"))
  },
  "/programs/:id": {
    component: loadable(() => import("pages/Program"))
  },
  "/programs": {
    component: loadable(() => import("pages/Programs"))
  },

  "/accounts/:id": {
    component: loadable(() => import("pages/Account"))
  },
  "/accounts": {
    component: loadable(() => import("pages/Accounts"))
  },
  "/tasks": {
    component: loadable(() => import("pages/Tasks"))
  },

  "/inbox": {
    component: loadable(() => import("pages/Inbox"))
  },
  // Dashboards
  "/dashboard": {
    component: loadable(() => import("pages/Dashboard"))
  }
};

class Routes extends React.Component {
  timeoutId = null;

  componentDidMount() {
    this.timeoutId = setTimeout(
      () =>
        Object.keys(loadableRoutes).forEach(path =>
          loadableRoutes[path].component.preload()
        ),
      5000 // load after 5 sec
    );
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  render() {
    return (
      <ConnectedSwitch>
        <Route exact path="/" component={Dashboard} />
        {Object.keys(loadableRoutes).map(path => {
          const { exact, ...props } = loadableRoutes[path];
          props.exact = exact === void 0 || exact || false; // set true as default
          return <Route key={path} path={path} {...props} />;
        })}
        <Route
          render={() => (
            <Page>
              <NotFoundPage />
            </Page>
          )}
        />
      </ConnectedSwitch>
    );
  }
}

export { loadableRoutes };
export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js